import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { AWSLoggerService } from '../services/aws.logger.service';

export const httpLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const loggerService = inject(AWSLoggerService);

  return next(req).pipe(
    tap({
      error: error => {
        if (error instanceof HttpErrorResponse) {
          loggerService.logError(error, {
            source: 'http-interceptor',
            requestUrl: req.url,
            method: req.method,
          });
        }
      },
    }),
  );
};
